import { VERSION } from 'constants/app';
import { COLOR_BACKGROUND } from 'constants/color';
import { MESSAGE_HELP_CONTENTS, MESSAGE_HELP_TITILE } from 'constants/message';
import { vw } from 'constants/size';
import React, { useState } from 'react';
import { StyleSheet, Text } from 'react-native';
import { Button, Modal, Portal } from 'react-native-paper';

const helpWidth = vw * 0.9;

const styles = StyleSheet.create({
	container: {
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
	},
	title: {
		flexShrink: 0,
		width: helpWidth,
		backgroundColor: '#ddd',
		textAlign: 'center',
		textAlignVertical: 'center',
		padding: 10,
	},
	contents: {
		flexShrink: 0,
		width: helpWidth,
		backgroundColor: COLOR_BACKGROUND,
		padding: 10,
	},
	extraInfo: {
		flexShrink: 0,
		width: helpWidth,
		backgroundColor: '#ddd',
		textAlign: 'right',
		textAlignVertical: 'center',
		padding: 10,
	},
});

const Help: React.VFC = () => {
	const [visible, setVisible] = useState<boolean>(false);

	const handlePress = () => {
		setVisible(true);
	};

	const handleDismiss = () => {
		setVisible(false);
	};

	return (
		<>
			<Button onPress={handlePress} mode="contained" icon="help">
				{MESSAGE_HELP_TITILE}
			</Button>
			<Portal>
				<Modal
					visible={visible}
					onDismiss={handleDismiss}
					contentContainerStyle={styles.container}>
					<Text style={styles.title}>{MESSAGE_HELP_TITILE}</Text>
					<Text style={styles.contents}>{MESSAGE_HELP_CONTENTS}</Text>
					<Text style={styles.extraInfo}>version: {VERSION}</Text>
					<Button
						onPress={handleDismiss}
						mode="contained"
						icon="close">
						{'閉じる'}
					</Button>
				</Modal>
			</Portal>
		</>
	);
};

export default Help;
